import { TransitEditorAction } from '../../models/types'
import useGenerateSubmitMessage from '../../transit-operation/components/useGenerateSubmitMessage'
import useDownloadTaxesCalculation from '../../transit-operation/components/useDownloadTaxesCalculation'
import useDownloadTSADPdf from '../../transit-operation/components/useDownloadTSADPdf'

function useDownloadActions(transitOperationId: number | null) {
  const { generateSubmissionMessage } = useGenerateSubmitMessage()
  const { downloadTaxesCalculation } = useDownloadTaxesCalculation()
  const { downloadTSADPdf } = useDownloadTSADPdf()

  const invokeDownloadAction = async (action: TransitEditorAction): Promise<void> => {
    if (!transitOperationId) {
      throw new Error('Missing transit operation ID')
    }

    switch (action) {
      case 'pdf':
        await downloadTSADPdf(transitOperationId)
        break
      case 'generateXml': {
        await generateSubmissionMessage(transitOperationId)
        break
      }
      case 'taxesXlsx':
      case 'taxesPdf': {
        await downloadTaxesCalculation(transitOperationId, action === 'taxesXlsx')
        break
      }
      default:
        break
    }
  }

  return {
    invokeDownloadAction,
  }
}

export default useDownloadActions
